import { useContext, useMemo } from 'react';
import { MutationParameters, PayloadError } from 'relay-runtime';
import { v4 as uuidv4 } from 'uuid';

import { SmxPropsTableContext } from '../providers/propsTableProvider';
import { getSetterTable, ITableState } from '../store/slices/tableSlice';
import { TableColumnSmxType } from '../types';
import useDispatchSetterStore from './useDispatchSetterStore';

const useCommitTableRecord = () => {
    const { nameQuery, prefixStore } = useContext(SmxPropsTableContext);
    const setterTable = useDispatchSetterStore<ITableState>(getSetterTable(nameQuery + prefixStore));

    const optimisticUpdater = (data: any, editableColumns: TableColumnSmxType[], id?: string) => (store: any) => {
        if (id) {
            const oldTableRecord = store.get(id);
            if (oldTableRecord) {
                editableColumns.map((field) => {
                    if (field.key in data) {
                        oldTableRecord.setValue(data[field.key], field.key);
                    }
                });
            }
            setterTable({ prefixFetchKeyUpdate: uuidv4() });
        }
    };

    const onCompleted =
        (namePartOfQuery: string, id?: string, successCallback?: (id: string) => void) =>
        (response: any, errors: PayloadError[]) => {
            if (errors) {
                console.log(
                    (
                        errors[0] as PayloadError & {
                            extensions: { debugMessage: string };
                        }
                    ).extensions.debugMessage,
                    errors,
                );
            } else {
                console.log('Request for TableRecord successful', response);
                successCallback && successCallback(id || response[namePartOfQuery]?.node?.id!);
            }
        };

    const onError = (error: any) => {
        console.error('Mutation error:', error);
    };

    const getCommitTableRecord = useMemo(
        () =>
            (
                data: any,
                connectionId: string,
                namePartOfQuery: string,
                editableColumns: TableColumnSmxType[],
                id?: string,
                successAdd?: (id: string) => void,
            ): MutationParameters => {
                delete (data as any).key;

                // const optimisticUpdateTableRecord = {
                //     [namePartOfQuery]: {
                //         id,
                //         ...data,
                //     },
                // };

                return {
                    variables: {
                        input: {
                            ...data,
                            id,
                        },
                        connections: [connectionId],
                    },
                    // optimisticResponse: id ? optimisticUpdateTableRecord : undefined,
                    onCompleted: onCompleted(namePartOfQuery, id, successAdd),
                    optimisticUpdater: id ? optimisticUpdater(data, editableColumns, id) : undefined,
                    onError: onError,
                } as any as MutationParameters;
            },
        [],
    );

    const getCommitTableRecordDelete = (
        id: string,
        connectionId: string,
        successDelete?: () => void,
    ): MutationParameters => {
        return {
            variables: {
                id,
                connections: [connectionId],
            },
            onCompleted: onCompleted('', id, successDelete),
            onError,
        } as any as MutationParameters;
    };

    return {
        getCommitTableRecord,
        getCommitTableRecordDelete,
    };
};

export default useCommitTableRecord;
